import { useLocation } from "react-router-dom";
import { MobileNav } from "./mobile-nav";
import { ThemeToggle } from "./theme-toggle";
import { UserMenu } from "./user-menu";
import { navSections } from "./nav-config";

function currentTitle(pathname: string): string {
  for (const section of navSections) {
    for (const item of section.items) {
      if (item.to === "/" && pathname === "/") return item.label;
      if (item.to !== "/" && pathname.startsWith(item.to)) return item.label;
    }
  }
  return "OpenClaw Sales";
}

export function Topbar() {
  const { pathname } = useLocation();
  const title = currentTitle(pathname);

  return (
    <header className="sticky top-0 z-20 flex h-14 items-center gap-3 border-b border-line bg-surface/85 px-4 backdrop-blur md:px-6">
      <MobileNav />
      <div className="min-w-0">
        <h1 className="text-md font-semibold text-ink truncate">{title}</h1>
      </div>
      <div className="ml-auto flex items-center gap-1">
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  );
}
